// byc-video-carousel.js

(function () {
  // Inicialización al cargar el DOM
  function initAllCarousels() {
    var roots = document.querySelectorAll('[data-byc-video-carousel]');
    if (!roots || roots.length === 0) return;
    roots.forEach(initCarousel);
  }

  // Soporte para OS 2.0 Theme Editor (cuando agregas la sección en vivo)
  function enableShopifyDesignMode() {
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (evt) {
        var root = evt.target && evt.target.querySelector('[data-byc-video-carousel]');
        if (root) initCarousel(root);
      });
      document.addEventListener('shopify:section:unload', function (evt) {
        // Si quieres limpiar listeners por sección, podrías hacerlo aquí
      });
    }
  }

  // ---- Inicializa UNA instancia (scope por 'root') ----
  function initCarousel(root) {
    if (!root) return;

    var carouselContainer = root.querySelector('.video-carousel-container');
    if (!carouselContainer) return; // guard final

    var videosPerView = parseInt(carouselContainer.getAttribute('data-videos-per-view'), 10) || 1;
    var videosPerViewTablet = parseInt(carouselContainer.getAttribute('data-videos-per-view-tablet'), 10) || 1;

    var videosToShow = 1;
    var carousel = root.querySelector('.video-carousel');
    var slides = root.querySelectorAll('.video-slide');

    function updateSlidesToShow() {
      if (window.innerWidth >= 1024) {
        videosToShow = videosPerView;
      } else if (window.innerWidth >= 768) {
        videosToShow = videosPerViewTablet;
      } else {
        videosToShow = 1;
      }
      var slideWidth = 100 / videosToShow;
      slides.forEach(function (slide) {
        slide.style.flex = '0 0 ' + slideWidth + '%';
      });
      // Reposicionar al cambiar tamaño
      moveCarousel(currentIndex);
    }

    // Throttle simple para resize
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateSlidesToShow, 120);
    });

    updateSlidesToShow();

    // Botones Prev/Next (scoped)
    var prevButton = document.createElement('button');
    var nextButton = document.createElement('button');
    prevButton.className = 'carousel-prev';
    nextButton.className = 'carousel-next';

    prevButton.innerHTML =
      '<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<circle r="17.5" transform="matrix(-1 0 0 1 18 18)" stroke="#042436"></circle>' +
      '<path d="M14.5234 13.4961L9.81889 18.2006L14.5234 22.9052" stroke="#042436"></path>' +
      '<path d="M10.0234 18.2031L26.1825 18.2031" stroke="#042436"></path>' +
      '</svg>';

    nextButton.innerHTML =
      '<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="18" cy="18" r="17.5" stroke="#042436"></circle>' +
      '<path d="M21.4766 13.4961L26.1811 18.2006L21.4766 22.9052" stroke="#042436"></path>' +
      '<path d="M25.9766 18.2031L9.81747 18.2031" stroke="#042436"></path>' +
      '</svg>';

    carouselContainer.appendChild(prevButton);
    carouselContainer.appendChild(nextButton);

    var currentIndex = 0;
    var totalSlides = slides.length;

    function moveCarousel(index) {
      var slideWidthPx = carouselContainer.offsetWidth / videosToShow;
      carousel.style.transform = 'translateX(-' + (index * slideWidthPx) + 'px)';
    }

    nextButton.addEventListener('click', function () {
      if (currentIndex < totalSlides - videosToShow) {
        currentIndex++;
      } else {
        currentIndex = 0;
      }
      moveCarousel(currentIndex);
    });

    prevButton.addEventListener('click', function () {
      if (currentIndex > 0) {
        currentIndex--;
      } else {
        currentIndex = Math.max(0, totalSlides - videosToShow);
      }
      moveCarousel(currentIndex);
    });

    // ---- Videos (scoped) ----
    var allVideos = root.querySelectorAll('.video-slide video');

    function playSequentially(videos, index) {
      if (!videos || videos.length === 0) return;
      if (typeof index !== 'number') index = 0;

      // Pausa todos y resetea
      videos.forEach(function (video) {
        try { video.pause(); } catch(e) {}
        try { video.currentTime = 0; } catch(e) {}
      });

      if (index >= videos.length) index = 0;
      var currentVideo = videos[index];
      if (!currentVideo) return;

      // Autoplay móvil requiere muted; por si acaso
      currentVideo.muted = true;
      var playPromise = currentVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function(){ /* silencioso */ });
      }

      currentVideo.onended = function () {
        playSequentially(videos, index + 1);
      };
    }

    playSequentially(allVideos, 0);

    // Controles por slide (scoped)
    root.querySelectorAll('.video-slide').forEach(function (slide) {
      var video = slide.querySelector('video');
      if (!video) return;

      var controls = document.createElement('div');
      controls.className = 'video-controls';

      var playPauseButton = document.createElement('button');
      playPauseButton.type = 'button';
      playPauseButton.textContent = '⏯';

      var muteButton = document.createElement('button');
      muteButton.type = 'button';
      muteButton.textContent = '🔇';

      playPauseButton.addEventListener('click', function () {
        if (video.paused) video.play(); else video.pause();
      });

      muteButton.addEventListener('click', function () {
        // Mutea otros videos de este carrusel
        root.querySelectorAll('.video-slide video').forEach(function (other) {
          if (other !== video) {
            other.muted = true;
            var otherBtn = other.closest('.video-slide').querySelector('.video-controls button:nth-child(2)');
            if (otherBtn) otherBtn.textContent = '🔇';
          }
        });
        video.muted = !video.muted;
        muteButton.textContent = video.muted ? '🔇' : '🔊';
      });

      controls.appendChild(playPauseButton);
      controls.appendChild(muteButton);
      slide.appendChild(controls);
    });
  }

  // ---- Bootstrap ----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }
  enableShopifyDesignMode();
})();
